<template>
    <b-list-group-item :class="`flex-column align-items-start ${event.action}`">
        <div class="d-flex w-100 justify-content-between">
        <h6 class="mb-1">

            <components-action :event="event" v-if="isComponentAction" />

            <media-action :event="event" v-if="isMediaAction" />

            <project-user-action :event="event" v-if="isProjectUserAction" />

            <auto-notification-action :event="event" v-if="isAutoNotification" />
            
        </h6>
        <small>{{ eventTime }}</small>
        </div>
    </b-list-group-item>
</template>

<style scoped lang="scss">
@import "@/assets/scss/style.scss";

.auto_notification, .project_notification, .component_notification {
    border-left: 5px solid $warning !important;
}
</style>

<script>
import moment from 'moment'
import ComponentsAction from './actions/components.vue'
import MediaAction from './actions/media.vue'
import ProjectUserAction from './actions/projectUser.vue'
import AutoNotificationAction from './actions/autoNotification.vue'

export default {
    name: "Event",
    components: {
        ComponentsAction,
        MediaAction,
        ProjectUserAction,
        AutoNotificationAction
    },
    props: {
        event: {
            type: Object
        }
    },
    data: function() {
        return {
            events: {
                media_deleted: "deleted media"
            }
        }
    },
    computed: {
        eventTime() {
            return moment(this.event.created_at).fromNow()
        },

        action() {
            return this.events[this.event.action] || "unknown action"
        },

        userName() {
            let user = this.$store.getters.getUser
            return user.uuid == this.event.user.uuid ? "You" : this.event.user.name
        },

        isComponentAction() {
            return this.event.action == "component_model_created" ||
                this.event.action == "component_model_edited" ||
                this.event.action == "component_model_deleted" ||
                this.event.action == "component_models_deleted" ||
                this.event.action == "component_model_disabled" ||
                this.event.action == "component_models_disabled" ||
                this.event.action == "component_model_enabled" ||
                this.event.action == "component_models_enabled" ||
                this.event.action == "component_settings_updated" ||
                this.event.action == "component_created" ||
                this.event.action == "component_deleted"
        },

        isMediaAction() {
            return this.event.action == "media_deleted" ||
                this.event.action == "media_uploaded" ||
                this.event.action == "media_dir_deleted"
        },

        isProjectUserAction() {
            return this.event.action == "project_user_invite" ||
                   this.event.action == "project_user_leave" ||
                   this.event.action == "project_user_invite_accept" ||
                   this.event.action == "project_user_deleted"
        },

        isAutoNotification() {
            return this.event.action == "auto_notification" ||
                   this.event.action == "project_notification" ||
                   this.event.action == "component_notification"
        }
    },
    methods: {
        rowClicked(item) {
            if (this.$can("inspect base_events")) {
                const link = "/admin/scout/events/" + item.uuid
                this.$router.push({path: link})
            }
        },
    }
}
</script>